
export const BP = Object.freeze({
    xs: 450,
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    "2xl": 1536,
});